import { Injectable } from '@angular/core';
import { sprintf } from 'sprintf-js';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  COLORS = [
		'#4dc9f6',
		'#f67019',
		'#f53794',
		'#537bc4',
		'#acc236',
		'#166a8f',
		'#00a950',
		'#58595b',
    '#8549ba',
    '#ba498f',
    '#495eba',
    '#10f541',
    '#b3e010',
    '#ecbfa4',
    '#ec98cc',
  ];
  
  constructor() { }

  localeDate2SystemDate(date: Date): string {
    let strDate = date.toLocaleString('th-TH');
    let arrDate = strDate.split('/');
    let year = parseInt(arrDate[2]);
    if (year > 2019)
      year -= 543;
    let sysdate = sprintf('%04d-%02d-%02d', year, arrDate[1], arrDate[0]);
    return sysdate;
  }

  localeDate2SystemDateTime(date: Date): string {
    let strDate = date.toLocaleString('th-TH');
    let time = strDate.split(' ')[1].trim();
    let arrDate = strDate.split('/');
    let year = parseInt(arrDate[2]);
    if (year > 2019)
      year -= 543;
    let sysdate = sprintf('%04d-%02d-%02d %s', year, arrDate[1], arrDate[0], time);
    return sysdate;
  }

  timeStrDiff(strdate1: string, strdate2: string): number {
    let date1 = new Date(strdate1);
    let date2 = new Date(strdate2);
    let timediff = date2.getTime() - date1.getTime();
    return Math.floor(timediff / 1000);
  }

  dateStrDiff(strdate1: string, strdate2: string): number {
    let date1 = new Date(strdate1);
    let date2 = new Date(strdate2);
    let timediff = date2.getTime() - date1.getTime();
    return Math.floor(timediff / (1000 * 3600 * 24));
  }

  dateDiff(indate1: Date, indate2: Date): number {
    let date1 = new Date(this.localeDate2SystemDate(indate1));
    let date2 = new Date(this.localeDate2SystemDate(indate2));
    let timediff = date2.getTime() - date1.getTime();
    return Math.floor(timediff / (1000 * 3600 * 24));
  }

  getTimeSlot(strtime: string): number {   //hh:mm:ss
    let arrTime = strtime.split(':');
    let h = parseInt(arrTime[0]);
    let m = parseInt(arrTime[1])
    return (h * 60) + m;
  }
  chgMinToTimeString(mintime: number): string {
    let h = mintime / 60;
    let m = mintime % 60;
    return sprintf('%02d:%02d', h, m);
  }

  getHours(strtime: string): number {
    let arrtime = strtime.split(':')[0];
    return parseInt(arrtime);
  }
  getMinutes(strtime: string): number {
    let arrtime = strtime.split(':')[1];
    return parseInt(arrtime);
  }
  getSeconds(strtime: string): number {
    let arrtime = strtime.split(':')[2];
    return parseInt(arrtime);
  }
}
